import { useEffect, useState, useContext } from "react";
import { io } from "socket.io-client";
import { Loader2, BadgeCheck } from "lucide-react";
import { listContas } from "./services/whatsappOficialApi";
import ConnectForm from "./components/ConnectForm";
import ContaCard from "./components/ContaCard";
import TabsContaConectada from "./components/TabsContaConectada";
import { SidebarContext } from "../../shared/context/SidebarContext";


export default function WhatsappOficial() {

    const { isOpen } = useContext(SidebarContext);
    const [contas, setContas] = useState([]);
    const [loading, setLoading] = useState(true);
    const [socket, setSocket] = useState(null);


    async function carregar() {
        setLoading(true);
        try {
            const data = await listContas();
            setContas(data);
        } catch (_) {
            setContas([]);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => { carregar(); }, []);

    useEffect(() => {
        const tokenFromCookie =
            document.cookie.split("; ").find((c) => c.startsWith("token="))?.split("=")[1] || null;
        const s = io(window.location.origin, {
            path: "/api/socket.io/",
            withCredentials: true,
            auth: tokenFromCookie ? { token: tokenFromCookie } : undefined,
        });
        setSocket(s);
        return () => { s.disconnect(); };
    }, []);


    const contaAtiva = contas.find((c) => c.status === "ativo") || contas[0];


    return (
        <div className="min-h-screen text-ink-1 flex relative z-0">
            <div className={`transition-all duration-300 ease-out-expo ${isOpen ? "lg:ml-64" : "sm:ml-16"} w-full max-w-full mb-16 sm:mb-0`}>

                <div className="px-5 sm:px-8 pt-8 pb-12 max-w-5xl mx-auto">

                    <header className="mb-8 animate-fade-in">
                        <div className="space-y-1">
                            <span className="chip-positive">
                                <BadgeCheck className="h-3 w-3" />
                                Cloud API oficial
                            </span>
                            <h1 className="display-2 flex items-center gap-3 mt-2">
                                WhatsApp Oficial
                                <BadgeCheck className="h-7 w-7 text-brand-400" strokeWidth={2.2} />
                            </h1>
                            <p className="text-ink-3 text-sm max-w-2xl">
                                Conexão direta com a Meta WhatsApp Cloud API via System User Token. Diferente do WhatsApp Sessões (QR não-oficial), aqui você usa a conta de negócio verificada — templates aprovados, métricas oficiais e webhook estável.
                            </p>
                        </div>
                    </header>

                    {loading ? (
                        <div className="surface-card p-12 grid place-items-center">
                            <Loader2 className="h-7 w-7 animate-spin text-brand-400 mb-3" />
                            <p className="text-sm text-ink-4">Carregando conta...</p>
                        </div>
                    ) : contaAtiva ? (
                        <div className="space-y-6 animate-slide-up">
                            <ContaCard conta={contaAtiva} onDisconnected={carregar} />
                            <TabsContaConectada conta={contaAtiva} socket={socket} />
                        </div>
                    ) : (
                        <ConnectForm onSuccess={carregar} />
                    )}

                </div>
            </div>
        </div>
    );
}
